/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const CustomerSchema = new Schema({
  birthDate: {
    type: 'string',
    format: 'date-time'
  },
  birthPlace: {
    type: 'string',
    maxLength: 255
  },
  employer: {
    type: 'string',
    maxLength: 255
  },
  name: {
    type: 'string',
    maxLength: 100
  },
  firstName: {
    type: 'string',
    maxLength: 50
  },
  lastName: {
    type: 'string',
    maxLength: 50
  },
  note: {
    type: 'string',
    maxLength: 1000
  },
  mobile: {
    type: 'string',
    maxLength: 15,
    pattern: '^(\\+?[0-9]+\\.)?[0-9]+$'
  },
  phone: {
    type: 'string',
    maxLength: 15,
    pattern: '^(\\+?[0-9]+\\.)?[0-9]+$'
  },
  rib: {
    type: 'string',
    pattern: '^\\d{5} \\d{5} \\d{11} \\d{2}$'
  },
  email: {
    type: 'string',
    format: 'email',
    maxLength: 100
  },
  email2: {
    type: 'string',
    format: 'email',
    maxLength: 100
  },
  address: {
    type: 'string',
    maxLength: 100
  },
  familySituation: {
    type: 'string',
    allowed: ['cohabitation', 'single', 'married']
  },
  fundingMethod: {
    type: 'string',
    allowed: ['cash', 'loan']
  },
  geographicAddress: {
    type: 'string',
    maxLength: 100
  },
  cityId: {
    type: 'integer'
  },
  profession: {
    type: 'string',
    maxLength: 200
  },
  isServiceProvider: {
    type: 'boolean'
    // required: true
  }
})

export default CustomerSchema
